import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xxl-8",
  style: {"margin-top":"-30px"}
}
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7" }
const _hoisted_5 = { class: "symbol symbol-150px symbol-lg-150px symbol-fixed position-relative d-flex flex-column" }
const _hoisted_6 = { class: "flex-grow-1" }
const _hoisted_7 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = { class: "d-flex flex-column mb-2" }
const _hoisted_10 = { class: "text-primary fs-2 fw-bolder" }
const _hoisted_11 = { class: "d-flex flex-row align-items-center" }
const _hoisted_12 = { class: "text-uppercase fw-bolder me-4 mb-0" }
const _hoisted_13 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex flex-row align-items-center mb-4"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt fs-1 text-primary me-4" }, null, -1)
const _hoisted_16 = { class: "d-flex flex-column" }
const _hoisted_17 = { class: "fw-bolder" }
const _hoisted_18 = {
  key: 1,
  class: "d-flex flex-row align-items-center mb-4"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-workspace fs-1 text-primary me-4" }, null, -1)
const _hoisted_20 = { class: "d-flex flex-column" }
const _hoisted_21 = { class: "fw-bolder" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "list-unstyled" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("span", {
      class: /*#__PURE__*/_normalizeClass(`badge badge-success`)
    }, /*#__PURE__*/_toDisplayString('estado'))
  ])
], -1)
const _hoisted_23 = { class: "d-flex my-4 align-items-center" }
const _hoisted_24 = { class: "me-3" }
const _hoisted_25 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_26 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_27 = { class: "nav-item" }
const _hoisted_28 = { class: "nav-item d-none" }
const _hoisted_29 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_btnBack = _resolveComponent("btnBack")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UploadFileModal = _resolveComponent("UploadFileModal")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_skeleton, { animated: "" }, {
                template: _withCtx(() => [
                  _createVNode(_component_el_image, {
                    class: "w-150px h-150px mb-4 rounded",
                    src: `${_ctx.REPO}/${_ctx.club.avatar}`,
                    fit: 'contain'
                  }, null, 8, ["src"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                link: "",
                onClick: _ctx.openUpload
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('edit')) + " " + _toDisplayString(_ctx.t('image')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.club?.abrev), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.club.name), 1),
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen026.svg" })
                    ])
                  ])
                ]),
                (_ctx.club?.address)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t('place')), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.club?.address), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.club?.country)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.t('country')), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.club?.country?.name) + " (" + _toDisplayString(_ctx.club?.country?.idcountry) + ")", 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_22
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_btnBack, {
                    to: `/${_ctx.company?.alias}/institutions`
                  }, null, 8, ["to"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("ul", _hoisted_26, [
            _createElementVNode("li", _hoisted_27, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/${_ctx.company?.alias}/institutions/${_ctx.id}/repman`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('representatives')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_28, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/${_ctx.company?.alias}/institutions/${_ctx.id}/afiliations`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Afiliaciones ")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_29, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/${_ctx.company?.alias}/institutions/${_ctx.id}/users`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('users')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loader]
    ]),
    _createVNode(_component_UploadFileModal, {
      ref: "uploadPhotoRef",
      extens: '.png, .jpg, jpeg',
      maxFileSizeMB: 1,
      "params-upload": _ctx.paramsUpload,
      allowedMIMEs: ['image/png', 'image/jpg', 'image/jpeg'],
      onUploadResponse: _ctx.uploadResponse
    }, null, 8, ["extens", "params-upload", "onUploadResponse"]),
    _createVNode(_component_router_view)
  ], 64))
}